import script from "./RtuSetpointsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./RtuSetpointsPanel.vue?vue&type=script&setup=true&lang=js"

import "./RtuSetpointsPanel.vue?vue&type=style&index=0&id=72971a4f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72971a4f"]])

export default __exports__